import { FC } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { FormLabel, StyledMargin } from '@dreryk/react-components';

import { StyledMedicalLeaveFormSectionColumn } from './StyledMedicalLeaveFormSectionColumn';

type MedicalLeaveFormWorkInabilityColumnProps = {
   readonly title?: TranslatableText;
   readonly maxWidth?: number;
};

export const MedicalLeaveFormSectionColumn: FC<MedicalLeaveFormWorkInabilityColumnProps> = (props) => (
   <StyledMedicalLeaveFormSectionColumn maxWidth={props.maxWidth}>
      {props.title ? (
         <StyledMargin bottom={8}>
            <FormLabel label={props.title} testId={'medicalLeaveSection'} />
         </StyledMargin>
      ) : null}
      {props.children}
   </StyledMedicalLeaveFormSectionColumn>
);
